import Request from "../../utils/Request";
import {AxiosResponse} from "axios";

const GetNotification = (): Promise<AxiosResponse<any>> =>
	Request.get(`/advisors/get-notifications`);

export default GetNotification;